export abstract class ApiModel<T = any> {
    protected constructor(
        protected _rawData: T
    ) {}

    /**
     * Установить значения атрибутов
     */
    protected abstract setAttributes(): void;

    /**
     * Получить данные от API в исходном виде
     */
    get rawData(): T {
        return this._rawData;
    }
}
